import * as React from 'react';
import { ModuleProps } from 'src/utils/module-util';
import { ExploreGalleryComponent } from 'src/components/common/modules/v1/explore-gallery/code-split/explore-gallery-component';

// Css Style Import
import(/* webpackChunkName: "v1-explore-gallery-styles" */ 'src/components/common/modules/v1/explore-gallery/styles/explore-gallery.css');

const ExploreGalleryModule = (props: ModuleProps) => {
  return (
    <ExploreGalleryComponent
      {...props}
      mccidData={{
        ...props.mccidData,
      }}
    />
  );
};

export { ExploreGalleryModule };
